<template>
  <div class="partner">
    <h2 class="fs30">我们的合作伙伴</h2>
    <swiper class="banner" :options="swiperOption">
      <swiper-slide class="swiper-img">
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/sy_Partner_icon1%402x.png" />
      </swiper-slide>
      <swiper-slide class="swiper-img">
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/sy_Partner_icon2%402x.png" />
      </swiper-slide>
      <swiper-slide class="swiper-img">
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/sy_Partner_icon3%402x.png" />
      </swiper-slide>
      <swiper-slide class="swiper-img">
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/sy_Partner_icon4%402x.png" />
      </swiper-slide>
      <swiper-slide class="swiper-img">
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/sy_Partner_icon5%402x.png" />
      </swiper-slide>
      <swiper-slide class="swiper-img">
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/sy_Partner_icon6%402x.png" />
      </swiper-slide>
      <swiper-slide class="swiper-img">
        <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/sy_Partner_icon7%402x.png" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
  export default {
    name: '',
    data () {
      return {
        swiperOption: {
          pagination: {
            el: '.swiper-pagination'
          },
          slidesPerView : 5,
          spaceBetween: 30,
          grabCursor: true,
          autoplay: {
            delay: 1500,
            disableOnInteraction: true
          },
          loop: true,
        }
      }
    }
  }
</script>
<style scoped>
  .partner{
    position: relative;
    margin: auto;
    background-color: #fafafa;
    padding-bottom: 80px;
  }
  .banner {
    height: 140px;
    max-width: 1200px;
  }
  .banner img{
    line-height: 0;
    font-size: 0;
    width: 18%;
    font-size: 0;
  }
  .swiper-img {
    width: 210px;
    height: 80px;
  }
  .swiper-img img {
    width: 100%;
    height: 100%;
  }
  .partner h2 {
    text-align: center;
    padding: 80px 0 60px 0;
  }
  .fs30 {
    font-size: 30px;
  }
  .partner >>> .swiper-pagination-bullet {
    width:32px;
    height:8px;
    background: #FF574E;
    opacity: .3;
    border-radius: 0;
  }
  .partner >>> .swiper-pagination-bullet-active {
    opacity: 1;
    width:32px;
    height:8px;
    background: #FF574E;
  }
  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 11%;
    left: 46%;
    width: 100%;
  }
  @media (max-width: 1199px) and (min-width: 992px){
    .partner h2 {
      text-align: center;
      padding: 60px 0;
    }
    .fs30 {
      font-size: 28px;
    }
    .banner {
      padding: 0 10px;
    }
  }
  @media (max-width: 991px) and (min-width: 768px){
    .partner h2 {
      text-align: center;
      padding: 40px 0;
    }
    .fs30 {
      font-size: 26px;
    }
    .banner {
      height: 150px;
      padding: 0 10px;
    }
  }
  @media screen and (max-width: 767px){
    .banner{
      padding-top: 0;
    }
    .partner h2 {
      text-align: center;
      padding: 27px 0;
      font-size: 20px;
      line-height: 24px;
    }
    .fs30 {
      font-size: 24px;
    }
    .banner {
      height: 60px;
      padding: 0 10px;
    }
    .swiper-pagination {
      display: none;
    }
  }
  @media (min-width: 768px){
  }
</style>




// WEBPACK FOOTER //
// src/components/index/partner/partner.vue